import isApiError from "@insite/client-framework/Common/isApiError";
import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import {
    SubmitDynamicFormApiRequestModel,
    SubmitDynamicFormApiResponseModel,
} from "@midland-industries/Types/DynamicFormModels";

const taxExemptionServiceUrl = "/api/v1/dynamicforms";

export async function submitDynamicFormDataToApi(
    parameter: SubmitDynamicFormApiRequestModel,
): Promise<ServiceResult<SubmitDynamicFormApiResponseModel>> {
    try {
        const results = await post<SubmitDynamicFormApiRequestModel, SubmitDynamicFormApiResponseModel>(
            `${taxExemptionServiceUrl}`,
            parameter,
        );
        return {
            successful: true,
            result: {
                success: true,
                submitToApiResponse: results.submitToApiResponse || "",
            },
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
